import {BuilderPot} from '../../../schema-types/BuilderPot';
import {PotDetails} from '../../../schema-types/PotDetails';

export const flattenAdHocFeeSources = (sourcePots: BuilderPot[]): PotDetails[] =>
  sourcePots.reduce<PotDetails[]>((acc, parentPot) => {
    acc.push(parentPot as PotDetails);
    parentPot.dentistChildren
      ?.filter((childPot) => childPot.id !== parentPot.id)
      .forEach((childPot) => {
        acc.push(childPot as PotDetails);
      });
    return acc;
  }, []);
